// MsgBox.jsx
import Modal from "../../components/Modal/Modal";
import { Button } from "../../components/Button/Button";
import { modalController, useModalContext } from "./ModalProvider";

// ─────────────────────────────
// 공통 UI 컴포넌트 (Modal 껍데기)
// ─────────────────────────────
function MsgBox({
  type,
  onAccept = () => {},
  onCancel = () => {},
  children,
}) {
  const isConfirm = type === "confirm";
  const { close } = useModalContext();

  return (
    <Modal className="dialog" handleOpenModal={close}>
      <Modal.Header>기술사업화지원센터</Modal.Header>
      <Modal.Body className="center">{children}</Modal.Body>
      <Modal.Footer>
        {isConfirm && (
          <Button type="button" onClick={onCancel}>
            <strong>취소</strong>
          </Button>
        )}
        <Button type="button" onClick={onAccept}>
          <strong>확인</strong>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MsgBox;

// ─────────────────────────────
// 전역에서 호출할 함수들
// ─────────────────────────────

export const openAlert = (message, onAccept) => {
  modalController?.open({
    name: "default-alert-modal",
    props: { message, onAccept },
  });
};

export const openConfirm = (message, onAccept, onCancel) => {
  modalController?.open({
    name: "default-confirm-modal",
    props: { message, onAccept, onCancel },
  });
};

// ─────────────────────────────
// Alert 컴포넌트
// ─────────────────────────────
export const Alert = () => {
  const { current, close } = useModalContext();

  if (current?.name !== "default-alert-modal") return null;

  const { message, onAccept } = current.props || {};

  return (
    <MsgBox
      type="default-alert-modal"
      onAccept={() => {
        close();
        onAccept?.();
      }}
    >
      {message}
    </MsgBox>
  );
};


// ─────────────────────────────
// Confirm 컴포넌트
// ─────────────────────────────
export const Confirm = () => {
  const { current, close } = useModalContext();

  if (current?.name !== "default-confirm-modal") return null;

  const { message, onAccept, onCancel } = current.props || {};

  return (
    <MsgBox
      type="default-confirm-modal"
      onAccept={() => {
        close();
        onAccept?.();
      }}
      onCancel={() => {
        close();
        onCancel?.();
      }}
    >
      {message}
    </MsgBox>
  );
};
